<template>
  <div class="flex items-center justify-center flex-wrap gap-3 my-5 relative">
    <el-pagination
        background
        :layout="layout"
        :total="total"
        :page-size="localSize"
        :current-page="localCurrentPage"
        :pager-count="pagerCount"
        @current-change="handleCurrentChange"
        :data-testid="`${id}-wrapper`"
    />

    <div class="sm:absolute sm:right-0 flex items-center flex-wrap space-x-2">
      <el-select
          v-model="localSize"
          @change="handleSizeChange"
          size="small"
          class="w-16 font-medium"
          :data-testid="`${id}-select`"
      >
        <el-option :value="10" label="10" />
        <el-option :value="20" label="20" />
        <el-option :value="25" label="25" />
        <el-option :value="50" label="50" />
      </el-select>

      <el-input
          v-model="jumpPage"
          :data-testid="`${id}-input`"
          :placeholder="$t('common.pagination.goTo')"
          @input="handleInputJumpPage"
          @keyup.enter.native="goToPage"
          @blur="goToPage"
          size="small"
          class="w-20 font-medium"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "Pagination",
  props: {
    layout: {
      type: String,
      default: 'prev, pager, next'
    },
    total: {
      type: Number,
      default: 0
    },
    size: {
      type: Number,
      default: 10
    },
    page: {
      type: Number,
      default: 1
    },
    id: {
      type: String,
      default: 'pagination'
    }
  },
  data() {
    return {
      localSize: this.size,
      localCurrentPage: this.page,
      jumpPage: null
    }
  },
  watch: {
    size(val) {
      this.localSize = val
    },
    page(val) {
      this.localCurrentPage = val
    }
  },
  computed: {
    pageCount() {
      return Math.ceil(this.total / this.localSize)
    },
    pagerCount() {
      return window.innerWidth < 640 ? 5 : 7
    }
  },
  methods: {
    handleCurrentChange(val) {
      this.localCurrentPage = val
      this.emitChange()
    },
    handleSizeChange(val) {
      this.localSize = val
      this.localCurrentPage = 1
      this.emitChange()
    },
    handleInputJumpPage(val) {
      let formattedVal = val.replace(/[^0-9]/g, '');
      this.jumpPage = formattedVal ? parseInt(formattedVal) : null;
    },
    goToPage() {
      if (this.jumpPage > 0 && this.jumpPage <= this.pageCount && this.localCurrentPage !== this.jumpPage) {
        this.localCurrentPage = this.jumpPage
        this.jumpPage = null
        this.emitChange()
      } else {
        this.jumpPage = null
      }
    },
    emitChange() {
      this.$emit('change', {page: this.localCurrentPage, size: this.localSize})
    }
  }
}
</script>